import { motion } from 'framer-motion';
import {
  Home, Hammer, Layers, Triangle, Maximize2,
  Shield, Droplets, Flame, Leaf, Wrench, Sun, HelpCircle
} from 'lucide-react';

const ICON_MAP = {
  Home, Hammer, Layers, Triangle, Maximize2,
  Shield, Droplets, Flame, Leaf, Wrench, Sun
};

const ServiceCard = ({ service, index }) => {
  const Icon = ICON_MAP[service.icon] || HelpCircle;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.5, delay: index * 0.08 }}
      className="group bg-white border border-slate-200 hover:border-[#0077D4] p-8 transition-all duration-300 hover:shadow-xl relative overflow-hidden"
      data-testid={`service-card-${index}`}
    >
      <div className="absolute top-0 left-0 w-1 h-0 group-hover:h-full bg-[#CC2229] transition-all duration-500" />

      <div className="w-14 h-14 bg-slate-50 group-hover:bg-[#0077D4] flex items-center justify-center transition-colors duration-300">
        <Icon size={28} className="text-[#0077D4] group-hover:text-white transition-colors duration-300" />
      </div>

      <h3 className="font-heading text-xl font-bold text-slate-900 mt-6 tracking-tight">
        {service.title}
      </h3>

      <p className="text-slate-500 mt-3 leading-relaxed text-sm">
        {service.description}
      </p>
    </motion.div>
  );
};

export const ServicesSection = ({ services }) => {
  if (!services || services.length === 0) return null;

  return (
    <section id="leistungen" className="py-20 md:py-32 bg-[#F8FAFC]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <span className="section-label text-[#CC2229]">Fachbereiche</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mt-4 tracking-tight uppercase">
            Unsere Leistungen
          </h2>
          <p className="text-slate-500 mt-4 max-w-2xl text-base sm:text-lg">
            Kompetente Dacharbeiten aus einer Hand — von der Neueindeckung bis zur Photovoltaik-Vorbereitung.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <ServiceCard key={service.id} service={service} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
